import { useAppDispatch, useAppSelector } from 'app/hooks';
import { Modal } from 'components/layout/modal/Modal';
import { Portal } from 'components/other/portal/Portal';
import { Transition } from 'components/other/transition/Transition';
import { closeThanks, selectCommon } from '../common.slice';
import { ThanksBody } from './thanksBody/ThanksBody';

export const Thanks = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const common = useAppSelector(selectCommon);

  return (
    <Transition active={common.ui.thanksOpened} timeout={300}>
      {(transitionStyles) => (
        <Portal blocked>
          <Modal
            onOverlayClick={() => dispatch(closeThanks())}
            className={transitionStyles}
          >
            <ThanksBody
              type={common.thanksModalType}
              onClose={() => dispatch(closeThanks())}
            />
          </Modal>
        </Portal>
      )}
    </Transition>
  );
};
